import { createReducer, on, Action } from '@ngrx/store';

import * as SearchActions from './search.actions';
import { SearchSortState } from './search.models';
import { SearchProductsSortType } from '@cpak/adp-cpak-products-service-models';
import { SearchAccountsSortType } from '@cpak/adp-cpak-accounts-service-models';
import { SearchPaksSortType } from '@cpak/adp-cpak-quotes-service-models';
import { SearchTarget, SortOrder } from '@cpak/adp-cpak-bff-service-models';

export const SEARCH_FEATURE_KEY = 'search';

export interface SearchState {
  [SearchTarget.accounts]: SearchSortState;
  [SearchTarget.paks]: SearchSortState;
  [SearchTarget.products]: SearchSortState;
}

export interface SearchPartialState {
  readonly [SEARCH_FEATURE_KEY]: SearchState;
}

export const initialSearchState: SearchState = {
  [SearchTarget.accounts]: {
    value: SearchAccountsSortType.NAME,
    order: SortOrder.asc,
  },
  [SearchTarget.paks]: {
    value: SearchPaksSortType.modifiedDate,
    order: SortOrder.desc,
    incorrectDefaultPackSortCleaned: false,
  },
  [SearchTarget.products]: {
    value: SearchProductsSortType.name,
    order: SortOrder.asc,
  },
};

const reducer = createReducer(
  initialSearchState,
  on(SearchActions.updateSearchSort, (state, { target, sort, sortOrder }) => ({
    ...state,
    [target]: { ...state[target], value: sort, order: sortOrder },
  })),
  on(SearchActions.resetSearchSort, (state, { target }) => ({
    ...state,
    [target]: { ...state[target], value: initialSearchState[target].value, order: initialSearchState[target].order },
  }))
);

export function searchReducer(state: SearchState | undefined, action: Action): SearchState {
  return reducer(state, action);
}
